import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SidebarItemListService } from '@shared/services/sidebar-item.service';
import { InvestmentJurisdictionShort } from 'src/app/modules/admin/models/investment-jurisdiction-short';

@Component({
  standalone: false,
  selector: 'gstar-tax-rate-summaries-container',
  templateUrl: './tax-rate-summaries-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxRateSummariesContainerComponent {
  private readonly translation = inject(TranslateService);
  private readonly sidebarItemListService = inject(SidebarItemListService);

  notFoundMessage: WritableSignal<string> = signal('');

  constructor() {
    this.sidebarItemListService.selectedCountry$.subscribe(
      (country: InvestmentJurisdictionShort | null | undefined) => {
        if (country) {
          this.notFoundMessage.set(
            this.translation.instant('countryInformation.noInfoFound', {
              country: country.name,
            })
          );
        }
      }
    );
  }
}
